import { Component, Input, OnInit, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material';
import { LoanService } from '../../../../../../service/finzy-flex/loan/loan.service';
import { InvestmentReversalResponse, LoanDetails } from '../../../../../../model/finzy-flex/loan-list.model';
import { Toaster, Type } from '../../../../../../toaster/Toaster';
import { InvestmentReversalPopUpComponent } from './investment-reversal-pop-up/investment-reversal-pop-up.component';
import { BorrowerDetailsPopUpComponent } from './borrower-details-pop-up/borrower-details-pop-up.component';
import { SignedDocumentType } from '../../../../../../model/finzy-flex/signed-document.model';
import { AccountService } from '../../../../../../service/finzy-flex/account/account.service';

@Component({
    selector: 'app-loan-table',
    templateUrl: './loan-table.component.html',
    styleUrls: ['./loan-table.component.scss']
})
export class LoanTableComponent implements OnInit {
    private sortingOrder: 'asc' | 'desc';
    private sortingColumn: string = '';
    private readonly loanService: LoanService;
    private readonly matDialog: MatDialog;
    @Input() loans: LoanDetails[];
    @Output() sort = new EventEmitter();
    constructor(loanService: LoanService, matDialog: MatDialog, private readonly accountService:AccountService) {
        this.loanService = loanService;
        this.matDialog = matDialog;
    }
    ngOnInit(): void {
        this.sortingOrder = 'asc';
    }

    private sorting(value: string) {
        (this.sortingOrder == 'asc') ? (this.sortingOrder = 'desc') : (this.sortingOrder = 'asc');
        return this.sort.emit(value);
    }

    public toggling(value: string) {
        if (value != this.sortingColumn) {
            this.sortingColumn = value;
            this.sortingColumn = 'asc';
            return this.sorting(value + ',' + this.sortingOrder);
        } else {
            return this.sorting(value + ',' + this.sortingOrder);
        }
    }

    public onClickLoanReverse(loan: LoanDetails) {
        this.matDialog.open(InvestmentReversalPopUpComponent, { panelClass: 'confirm-dialog-responsive' }).afterClosed().subscribe(async result => {
            if (result) {
                await this.loanService.investmentReversal(loan.portfolioId, loan.loanId)
                    .then((res: InvestmentReversalResponse) => {
                        if (!res.status) {
                            Toaster.toast(res.data[0], Type.Success);
                            this.loans = this.loans.filter(l => l.loanId !== loan.loanId);
                        } else {
                            Toaster.toast(res.data[0], Type.Error);
                        }
                    })
                    .catch(() => Toaster.toast(`Something went wrong, please try again after some time!!!`, Type.Error))
            }
        })
    }

    public onClickBorrowersDetail(loan: LoanDetails){
        this.matDialog.open(BorrowerDetailsPopUpComponent, {data: loan, width: '62vw', panelClass: 'borrower-details-popup'});
    }

    public async onDownloadLoanAgreement(loan: LoanDetails) {
        try {
            // const signedDocuments = await this.loanService.getConsolidatedSignedDocument(loanId);
            // if (signedDocuments.status == 0) {
                // window.open(signedDocuments.data[0].source);
                const response = await this.loanService.getConsolidatedSignedDocument(loan.loanId);
                if(response.size) {
                    // window.location.href = response;
                    const interestCertificateFile = response;
                    let downloadUrl = URL.createObjectURL(interestCertificateFile);
                    let downloadElem = document.createElement('a');
                    downloadElem.href = downloadUrl;
                    downloadElem.download = `${loan.loanShortId}-contract.pdf`;
                    downloadElem.click();
                } else {
                    Toaster.toast('Loan Agreement is not available yet, please check back later!', Type.Error);
                }
                
            // } else {
            //     Toaster.toast('Loan Agreement is not available yet, please check back later!', Type.Error);
            // }
        } catch(error) {
            Toaster.toast(`Something went wrong`, Type.Error);
        }
    }


    public async downloadContractDoc(fileUrl: string) {
        try {
            const fileName = fileUrl.slice(fileUrl.lastIndexOf('/')+1); 
            this.accountService.getFileByName(fileName)
                .then((res) => {
                    let downloadUrl = URL.createObjectURL(res);
                    let downloadElem = document.createElement('a');
                    downloadElem.href = downloadUrl;
                    downloadElem.download = `${fileName}`;
                    downloadElem.click();
                })
                .catch((err) => {
                    console.log(err)
                })
        } catch(e) {
            console.log(e)
        }
    }
}
